import { render, staticRenderFns } from "./TypeStaticCity.vue?vue&type=template&id=585b517c&scoped=true&"
import script from "./TypeStaticCity.vue?vue&type=script&lang=js&"
export * from "./TypeStaticCity.vue?vue&type=script&lang=js&"
import style0 from "./TypeStaticCity.vue?vue&type=style&index=0&id=585b517c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585b517c",
  null
  
)

export default component.exports